export const locale = {
    lang: 'pl',
    data: {
        'Add discount': 'Dodaj rabat',
        'Name': 'Nazwa',
        'Value': 'Wartość',
        'Available date': 'Okres obowiązywania',
        'Created at': 'Utworzono',
        'Actions': 'Akcje',
        'Edit': 'Edycja',
        'Delete': 'Usuń',
        'Confirm deletion': 'Potwierdź usunięcie',
        'Are you sure you want to delete selected discount?': 'Czy usunąć wybrany rabat?',
        'Cancel': 'Anuluj',
        'Confirm': 'Potwierdź',
        'Type': 'Typ',
        'Percent': 'Procentowy',
        'Minimal quahtity of products': 'Minimalna ilość produktów',
        'Minimal quantity of lines': 'Minimalna ilość linii',
        'Minimal quantity of vouchers': 'Minimalna ilość karnetów',
        'Voucher groups': 'Grupy karnetów',
        'Available one time first day': 'Dostępny tylko raz pierwszego dnia',
        'Can connect with other discounts': 'Może się łączyć z innymi rabatami',
        'Discount calculated from net price': 'Rabat obliczany od ceny netto',
        'Discount calculated from gross price': 'Rabat obliczany od ceny netto',
        'Available from date': 'Dostępny od',
        'Available to date': 'Dostępny do',
        'Discount data': 'Dane rabatu',
        'Save': 'Zapisz',
        'Discounts': 'Rabaty',
        'New': 'Nowy',
    }
};
